import { InsightsState } from 'app-redux/InsightsState';

const isLoading = (state: InsightsState) => state.metadata.isLoading;
const hasError = (state: InsightsState) => state.metadata.hasError;
const getMetadata = (state: InsightsState) => state.metadata.metadata;

// metadataSelectors
export default {
  isLoading,
  hasError,
  getMetadata,
};
